export type ActiveTwin = {
  planDate: string;
  itemKey: string;
};

export type AnsweredTask = {
  planDate: string;
  itemKey: string;
  twinItemKey: string | null;
};

/**
 * Незаконченные близнецы живут дольше одного экрана задачи: ученик может уйти
 * по навигации набора и вернуться. Ответ убирает решённого близнеца, а новый
 * добавляется в конец — ошибки по другим задачам при этом не теряются.
 */
export function updateActiveTwins(
  current: ActiveTwin[],
  answered: AnsweredTask,
): ActiveTwin[] {
  const remaining = current.filter(
    (twin) =>
      twin.planDate !== answered.planDate || twin.itemKey !== answered.itemKey,
  );

  if (
    answered.twinItemKey === null ||
    remaining.some(
      (twin) =>
        twin.planDate === answered.planDate &&
        twin.itemKey === answered.twinItemKey,
    )
  ) {
    return remaining;
  }

  return [
    ...remaining,
    { planDate: answered.planDate, itemKey: answered.twinItemKey },
  ];
}

export function activeTwinsForPlan(
  activeTwins: ActiveTwin[],
  planDate: string | undefined,
): string[] {
  return activeTwins
    .filter((twin) => twin.planDate === planDate)
    .map((twin) => twin.itemKey);
}

/** Первый ожидающий близнец, кроме уже открытого. */
export function nextActiveTwin(
  activeTwinItemKeys: string[],
  currentItemKey: string,
): string | null {
  return activeTwinItemKeys.find((key) => key !== currentItemKey) ?? null;
}
